export default defineAppConfig({
  authLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    authLayer?: {};
  }
}
